// pages/ExportData.js

import Header from "../components/HomeScreen/Header";
import ExportPdfAndCsv from "../components/MenuScreen/ExportPdfAndCsv";
import Footer from "../components/HomeScreen/Footer";

const ExportData = () => {
  return (
    <>
      <Header />
      <ExportPdfAndCsv />
      <Footer />
    </>
  );
}
export default ExportData;
